/* eslint-disable prettier/prettier */
/* This file is automatically generated by the plugin 'request-plugin'. Please do not modify. */

type URLArgs = ConstructorParameters<typeof URL>;
  
  type URLParams = Record<string, string | number | boolean>;
    
  function generateURL (options: { baseURL?: URLArgs[1]; } = {}) {
    const { baseURL } = options;
    return class extends URL {
      constructor (url: URLArgs[0], params?: URLParams, base?: URLArgs[1]) {
        super(url, base || baseURL || location.origin);
        if (params) {
          for (const k in params) {
            this.searchParams.set(k, params[k] as string);
          }
        }
      }
    };
  }
  
  export default Object.assign(generateURL({baseURL: 'https://chatapi.halochat.io'}), {
  WS: generateURL({baseURL: 'wss://chatapi.halochat.io'}),
  });